import { uniqueId } from 'lodash';
import moment from 'moment';
import PropTypes from 'prop-types';
import { memo, useState } from 'react';
import { Loader, Select, Table } from '../../common/components';
import { dateFormat } from '../../constants/formats';
import { formatPrice } from '../../utils/formatters';
import DashboardInfoLabel from './utils/DashboardInfoLabel';
import NoData from './utils/no-data';

function TitleSubTitle(title, subTitle) {
  return (
    <div className="title-sub-wrapper">
      <p className="title-sub-title">{title}</p>
      <p className="title-sub-sub">{subTitle}</p>
    </div>
  );
}

function DashboardRecentContracts({ headers, data, duration, loader }) {
  const [showingRows, setShowingRows] = useState({ value: 5, label: '5' });
  const paymentStatus = {
    PAID: 'td-payment-paid',
    UNPAID: 'td-payment-unpaid',
    PARTIALLY: 'td-payment-partial',
  };

  const durationNote = `${
    duration?.duration?.value !== 'custom'
      ? duration?.duration?.label
      : `${moment(duration?.range?.startDate).format('MM/DD/YYYY')} - ${moment(
          duration?.range?.endDate,
        ).format('MM/DD/YYYY')} custom`
  } duration`;

  return (
    <div className="dashboard-recent-validated-contracts">
      <div className="title-wrapper">
        <div className="title-subtitle">
          <DashboardInfoLabel
            id={uniqueId('recent-submitted-contracts')}
            label="Submitted Contracts"
            showIcon
            size="md"
            toolTipText="This will show the list of recently submitted contracts in One Portal"
          />
          <p className="table-caption">{durationNote}</p>
        </div>
        <div className="showing-rows-wrapper">
          <span className="row-label">showing rows:</span>
          <Select
            required
            formInput={false}
            options={[
              { value: 5, label: '5' },
              { value: 10, label: '10' },
              { value: 15, label: '15' },
            ]}
            value={showingRows}
            isSearchable={false}
            onChange={(option) => {
              setShowingRows(option);
            }}
          />
        </div>
      </div>
      <Table headers={headers} className="dashboard-recent-list-table" responsive>
        {loader && (
          <tbody>
            <tr className="dashboard-table-row">
              <td className="td-no-data" colSpan={headers.length}>
                <Loader />
              </td>
            </tr>
          </tbody>
        )}
        {!loader && data.length > 0 && (
          <tbody>
            {data.slice(0, showingRows.value).map((row, index) => (
              <tr key={`dashboard-table-row-${index + 1}`} className="dashboard-table-row">
                <td className="dash-table-td td-opi">
                  {TitleSubTitle(row.purchaserName, row.opiID)}
                </td>
                <td className="dash-table-td td-contract">{row.contractNumber}</td>
                <td className="dash-table-td td-dot">
                  {row.dateOfTransaction ? moment(row.dateOfTransaction).format(dateFormat) : '-'}
                </td>
                <td className="dash-table-td dash-table-due">
                  {TitleSubTitle(
                    `${formatPrice(row.dueAmount)}`,
                    `/ ${formatPrice(row.totalPaid)}`,
                  )}
                </td>
                <td
                  className={`dash-table-td td-status ${
                    paymentStatus[row.payment.split(' ')[0].toUpperCase()]
                  }`}
                >
                  {row.payment}
                </td>
              </tr>
            ))}
          </tbody>
        )}{' '}
        {!loader && !data.length && (
          <tbody>
            <tr className="dashboard-table-row">
              <td className="td-no-data" colSpan={headers.length}>
                <NoData />
              </td>
            </tr>
          </tbody>
        )}
      </Table>
    </div>
  );
}

DashboardRecentContracts.propTypes = {
  headers: PropTypes.arrayOf(PropTypes.any.isRequired),
  data: PropTypes.arrayOf(PropTypes.any.isRequired),
  duration: PropTypes.string,
  loader: PropTypes.bool.isRequired,
};
DashboardRecentContracts.defaultProps = {
  headers: [],
  data: [],
  duration: 'Last X',
};

export default memo(DashboardRecentContracts);
